import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-signout-modal',
  templateUrl: './signout-modal.component.html',
  styleUrls: ['./signout-modal.component.scss']
})
export class SignoutModalComponent {
  title: string = '';

  constructor(public activeModal: NgbActiveModal) { }
}
